const routes = {
  createCity: 'city',
  getCities: 'city',
  getCityById: 'city/',
  updateCity: 'city/',
  deleteCity: 'city/',
};

export default routes